<div class="loadingbar bg-primary fixed" *ngIf="loading | async"></div>
